import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { UpdateTag, UpdateTagDefaultValues } from 'src/app/components/tags/tags';
import { TagsService } from 'src/app/services/tag-service.service';
import { ToastService } from 'src/app/services/toast-service.service';

@Component({
    selector: 'app-edit-tag',
    templateUrl: './edit-tag.component.html',
    styleUrls: ['./edit-tag.component.scss'],
    standalone: false
})
export class EditTagComponent {

  tag: UpdateTag = UpdateTagDefaultValues();
  tagCategories: any[] = [];
  selectedCategory: any[] = [];
  isSubmitted = false;
  tagStatus: string = "active";
  hideReviewPanel: boolean = true;
  pageName = CheckPageAccess.EDITTAG;

  constructor(public _tagservice: TagsService, public _toastService: ToastService, public router: Router, public route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this._tagservice.getTagDetailsById(params['id']).subscribe({
        next:(details) => {
          this.tag = details;
          this.selectedCategory = details.tagCategories.map((i: { id: any; }) => i.id);

          if (this.tag.isActive) {
            this.tagStatus = "active";
          }
          else {
            this.tagStatus = "inactive";
          }

          this._tagservice.getAllCategories().subscribe({
            next: (data) => {
              this.tagCategories = data
            },
            error: (error) => console.log(error)
          });
        }
      });
    });
  }

  getCategoryNames(id: number): string {
    const cat = this.tagCategories.find(t => t.id === id);
    return cat ? cat.categoryName : '';
  }

  updateTag() {
    this._tagservice.updatetag(this.tag).subscribe({
        next: (res) => {
          if (res) {
            this._toastService.showMessage("Tag Updated successfully");
            this.router.navigateByUrl("/tags-list");
          }
          else {
            this._toastService.showMessage("Error in creating tag");
          }
        }
      });
  }

  review(_t48: NgForm) {
    this.isSubmitted = true;
    this.tag.tagCategoryId = this.selectedCategory;//.map((i) => i.id);

    if (this.tagStatus == 'active') {
      this.tag.isActive = true;
    }
    else {
      this.tag.isActive = false;
    }

    if (!this.validateTagForm()) {
      return;
    }

    this.updateTag();
  }

  goback() {
    this.hideReviewPanel = true;
  }

  validateTagForm(): boolean {
    let flag = true;

    if (this.tag.tagName == '') {
      flag = false;
    }

    if (this.tag.tagCategoryId.length == 0) {
      flag = false;
    }

    return flag;
  }
}
